export default __webpack_public_path__ + "static/media/img-0750-romania-half-face.9f51cc3a.png";